import UIkit from 'uikit';
$(document).ready(function( $ ) {
    $(window).scroll(function(){
        var component = UIkit.sticky('#js-header-sticky');
        if (document.body.scrollTop == 0 || document.documentElement.scrollTop == 0) {
            component.$emit(event = 'update');
        }
    });
});